<template>
    <div>
      <feather-icon v-if="!isDeleted" class="mt-2"  icon="Edit3Icon" svgClasses="h-5 w-5 mr-4 mt-2 hover:text-primary cursor-pointer" @click="editRecord" :title="$t('Edit')" />
      <feather-icon v-if="!isDeleted" icon="Trash2Icon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer" @click="openDeleteConfirm" :title="$t('Delete')" />
      <feather-icon v-if="isDeleted" icon="XIcon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer" @click="openRestoreConfirm" :title="$t('MRMR.Entry.Restore')" />
      <div v-if="isNew" class="feather-icon ml-3" style="line-height:20px;">
          <vs-chip color="primary" >
          {{ $t('New') }}
        </vs-chip>
      </div>
      <div v-if="isDeleted" class="feather-icon ml-3" style="line-height:20px;">
          <vs-chip color="danger" >
           {{ $t('Deleted') }}
        </vs-chip>
      </div>
     
    </div>
</template>

<script>
export default {
  name: 'EntryActionsCellRenderer',
  computed: {
    isDeleted() {
      return this.params.data.isDeleted;
    },
    isNew() {
      return this.params.data.isNew;
    }
  },
  methods: {
    editRecord () {
      this.params.context.componentParent.editData(this.params.data);
    },

    openDeleteConfirm() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: name,
        text: this.$t('MRMR.Entry.ConfirmDelete'),
        accept: this.deleteRecord
      });
    },

    openRestoreConfirm() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: name,
        text: this.$t('MRMR.Entry.ConfirmRestore'),
        accept: this.restoreRecord
      });
    },
    deleteRecord () {
      this.params.context.componentParent.deleteData(this.params.rowIndex);
    },
    restoreRecord () {
      this.params.context.componentParent.restoreData(this.params.rowIndex);
    }
  }
}
</script>
